import React, { useEffect, useState } from "react";
import { ConfigProvider, Tabs } from "antd";
import zhCN from "antd/lib/locale/zh_CN";
import { getPlatformList, getWarningTypeList } from "../../service";
import type { TabsProps } from 'antd';
import BudgetTable from './components/budgetTable';
import { PlatformType } from '../../../../utils/constant';

const tabs:TabsProps['items'] = [
    {
        key: PlatformType.FACEBOOK,
        label: PlatformType.FACEBOOK,
        children: <BudgetTable key={PlatformType.FACEBOOK} platform={PlatformType.FACEBOOK}/>
    },
    {
        key: PlatformType.GOOGLE,
        label: PlatformType.GOOGLE,
        children: <BudgetTable key={PlatformType.GOOGLE} platform={PlatformType.GOOGLE}/>
    }
];

export default function BudgetPage() {

    return <ConfigProvider locale={zhCN} theme={{
        token: {
            fontSize: 16,
            paddingSM: 16,
            controlHeight: 40
        },
        components: {
            Table: {
                headerBg: '#F2F5F9',
                headerColor: '#52c41a',
                headerSortHoverBg: '#F0FAFF',
                headerSortActiveBg: '#95de64'
            },
            Tabs: {
                titleFontSizeLG: 28
            }
        }
    }}>
        <Tabs size="middle" type="card" defaultActiveKey={'facebook'} items={tabs} onChange={() => {}}/>
    </ConfigProvider>
}